<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <!-- <el-form-item label="报价轮次:">
                <el-input size="mini" v-model="dataForm.roundNo" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="原材料:">
                <el-input size="mini" v-model="dataForm.rawMaterial" clearable></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" row-key="index" size="mini" border style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" :height="tableHeight">
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <el-table-column prop="partCode" width="150" header-align="center" align="left" label="零件号" fixed></el-table-column>
            <el-table-column prop="partName" width="150" header-align="center" align="left" label="零件名称" fixed></el-table-column>
            <el-table-column label="详细状况" align="center">
                <el-table-column prop="rawMaterial" width="150" header-align="center" align="left" label="原材料">
                </el-table-column>
                <el-table-column prop="priceCost" width="150" header-align="center" align="right" label="原材料价格元/Kg(A)">
                    <template slot-scope="scope">
                        {{scope.row.priceCost}}
                    </template>
                </el-table-column>
                <el-table-column prop="weight" width="150" header-align="center" align="right" label="投入重量 Kg/个(B)">
                </el-table-column>
                <el-table-column prop="materialTotal" width="150" header-align="center" align="right" label="原材料小计(C=A×B)">
                    <template slot-scope="scope">
                        {{scope.row.materialTotal}}
                    </template>
                </el-table-column>
                <el-table-column label="废料计算" align="center">
                    <el-table-column prop="wasteCost" width="150" header-align="center" align="right" label="废料价格(D)">
                        <template slot-scope="scope">
                            {{scope.row.wasteCost}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="wasteWeight" width="150" header-align="center" align="right" label="废料重量 Kg/个(E)"></el-table-column>
                    <el-table-column prop="wasteTotal" width="150" header-align="center" align="right" label="废料小计(F=D×E)">
                        <template slot-scope="scope">
                            {{scope.row.wasteTotal}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="lastTotal" width="150" header-align="center" align="right" label="小计(G=C-F)">
                    <template slot-scope="scope">
                        {{scope.row.lastTotal}}
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
            </el-table-column>
            <el-table-column header-align="center" align="left" width="100" label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                        查看
                    </el-button>
                    <!--<el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                        删除
                    </el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshMateralDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    quotationMateralList,
    quotationMateralDelete
} from '@/controller/quotation'
import AddOrUpdate from './quotationMateral-add-or-update'
import moment from 'moment'
// require('@/mock/mockQuotation');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                priceCost: 0,
            },
            viewFlag: '',
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    components: {
        AddOrUpdate
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    // activated() {
    //     this.getDataList()
    // },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 新增或编辑子节点
        addChildHandle(id, parentId, parentName, parentNodePath) {
            console.log(id, parentId, parentName, parentNodePath)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
            })
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            quotationMateralList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                // totalPage: this.totalPage,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm)
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                quotationMateralDelete({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss">
.fr {
    float: right;
}

.button-danger {
    color: #F56C6C;
}
</style>
